import { css } from 'styled-components';
export const flatUnderline = css `
  .tab-header {
    position: relative;

    .nav-tabs {
      width: 100%;
      max-width: 100%;
      border: 0;
      z-index: 2;
      border-bottom: 1px solid ${(props) => props.theme.tabsBorderBottom};
      font-size: ${(props) => props.theme.fontSmall};
      color: ${(props) => props.theme.darkGray};
      background: ${(props) => props.theme.background};

      .nav-item {
        cursor: pointer;
        margin-left: 0;
        margin-right: 0;
        padding-left: 15px;
        padding-right: 15px;
      }
      .nav-link {
        padding-left: 0;
        padding-right: 0;
        border: 0;
        border-bottom: 2px solid transparent;
        color: ${(props) => props.theme.tabUnselected};
        text-transform: uppercase;

        .tab-title {
          font-weight: ${(props) => props.theme.semibold};
        }

        &.active,
        &:hover {
          color: ${(props) => props.theme.tabSelected};
          background: ${(props) => props.theme.background};
          border-bottom: 2px solid ${(props) => props.theme.activeTabUnderline};
        }

        &.active {
          cursor: default;
        }
      }
    }
  }
`;
export const light = css `
  .nav-tabs {
    background: ${(props) => props.theme.vLightBlue};
    border: 0;
    .nav-item {
      margin-left: 0;
      margin-right: 0;

      &:first-child {
        margin-left: 0;
        margin-bottom: 1px;
        .nav-link {
          border-left: 1px solid ${(props) => props.theme.lightGray};
        }
      }
      &:last-child {
        .nav-link {
          border-right: 1px solid ${(props) => props.theme.lightGray};
        }
      }
    }
    .nav-link {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      color: ${(props) => props.theme.darkGray};
      text-transform: uppercase;
      background-color: ${(props) => props.theme.vLightGray};
      border-color: ${(props) => props.theme.lightGray};
      border-left: 1px solid ${(props) => props.theme.lightGray};
      &.active,
      &:hover {
        background-color: #fff;
        border-color: ${(props) => props.theme.vLightGray}
          ${(props) => props.theme.vLightGray} #fff;
        color: ${(props) => props.theme.navyBlue};
      }
    }
  }
  .tab-content {
    padding: 0;
  }
  .tab-title {
    font-weight: ${(props) => props.theme.normal};
    white-space: nowrap;
  }

  .tab-header {
    position: relative;
    margin-bottom: -2px;
    border-bottom: 0;
  }

  .wrapper-content {
    border-top: 1px solid #e8e9eb;
    background: #fff;
  }
`;
